import React, { Component, useCallback, useEffect, useState } from "react";
import { connect } from "react-redux";

import { SideBar } from "../../components/common/side-bar";
import { CustomerSideBar } from "../../components/common/customer-side-bar";
import Header from "../../components/header/header";
import { browserHistory } from "../../common/utils/history";
import { useHistory, useLocation } from "react-router-dom";
import { useResize } from "../../hooks/useResize";

const MainLayoutF = ({ children, roles }) => {
  const history = useHistory();
  const { pathname } = useLocation();
  const [onCollapse, setOnCollapse] = useState(true);
  const resize = useResize(997);

  const toggleCollapse = useCallback(() => {
    setOnCollapse(!onCollapse);
  }, [onCollapse]);

  useEffect(() => {
    setOnCollapse(resize);
  }, [resize]);

  useEffect(() => {
    if (
      roles &&
      !roles.includes("Admin") &&
      !roles.includes("Sale") &&
      !roles.includes("Superuser") &&
      pathname !== "/notification" &&
      pathname !== "/customer-pr" &&
      pathname !== "/customer-review" &&
      pathname !== "/journey-diary"
    ) {
      history.push("/notification");
    }
    if (
      roles &&
      roles.includes("Superuser") &&
      pathname !== "/" &&
      pathname !== "/customer" &&
      pathname !== "/vehicle" &&
      pathname !== "/journey-diary" &&
      pathname !== "/driver" &&
      pathname !== "/summary-report" &&
      pathname !== "/review" &&
      pathname !== "/user-account" &&
      pathname !== "/user-permission"
    ) {
      history.push("/");
    }
    if (
      roles &&
      roles.includes("Admin") &&
      pathname !== "/" &&
      pathname !== "/customer" &&
      pathname !== "/vehicle" &&
      pathname !== "/journey-diary" &&
      pathname !== "/driver" &&
      pathname !== "/summary-report" &&
      pathname !== "/review"
    ) {
      history.push("/");
    }
    if (
      roles &&
      roles.includes("Sale") &&
      pathname !== "/" &&
      pathname !== "/customer"
    ) {
      history.push("/");
    }
  }, [history, roles]);

  return (
    <div className="home">
      <Header history={browserHistory} onCollapse={toggleCollapse} />
      {roles &&
      !roles.includes("Admin") &&
      !roles.includes("Sale") &&
      !roles.includes("Superuser") ? (
        <CustomerSideBar
          onCollapse={onCollapse}
          setOnCollapse={setOnCollapse}
        />
      ) : (
        <SideBar onCollapse={onCollapse} setOnCollapse={setOnCollapse} />
      )}
      <div id="right-layout" className="content right-layout">
        <div className="body">{children}</div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    roles: state.auth ? state.auth.roles : null,
  };
};

export const MainLayout = connect(mapStateToProps)(MainLayoutF);
